<div class="card-header bg-white" *ngIf="accessService.authorized(project, 'EDIT_GOALS')">

    <ng-template #authTemplate><div [innerHtml]="accessService.authReason(project, 'EDIT_GOALS')"></div></ng-template>
    <button type="button" class="btn btn-primary" placement="right" containerClass="auth-tooltip"
            *ngIf="viewMode === ViewMode.VIEW"
            (click)="setMode(ViewMode.EDIT)"
            [tooltip]="authTemplate"
            [delay]="500">Bearbeiten
    </button>

    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>
</div>
<div class="card-body">
    <form [formGroup]="form">
        <div class="mb-2">
            <label>Projekttitel</label>
            <ng-container *ngIf="viewMode !== ViewMode.VIEW">
                <input type="text" class="form-control" formControlName="title_project" [maxlength]="80"
                   [disableControl]="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && accessService.hasRoles(project, TeamRole.Lead)">
                <div class="mb-1 small">{{ form.value.title_project ? form.value.title_project.length : 0 }}/80</div>
            </ng-container>
            <p *ngIf="viewMode === ViewMode.VIEW">
                {{ form.value.title_project }}
                <span class="text-danger" *ngIf="!form.value.title_project">Nicht eingetragen</span>
            </p>
        </div>

        <div class="mb-2">
            <label>Strategische Zuordnung</label>
            <select class="form-control" formControlName="strategic_classification_root"
                    *ngIf="viewMode !== ViewMode.VIEW"
                    [disableControl]="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && accessService.hasRoles(project, TeamRole.Lead)">
                <option value="" disabled selected style="display: none;">Wählen Sie jene Strategie-Säule aus, auf die das Projekt aus Ihrer Sicht den größten Einfluss hat</option>
                <option *ngFor="let classification of strategicClassifications" [ngValue]="classification">
                    {{ classification.name }}
                </option>
            </select>
            <select class="form-control" formControlName="strategic_classification"
                    *ngIf="viewMode !== ViewMode.VIEW && form.value.strategic_classification_root"
                    [disableControl]="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && accessService.hasRoles(project, TeamRole.Lead)">
                <option value="" disabled selected style="display: none;">Bitte auswählen</option>
                <option *ngFor="let sub of form.value.strategic_classification_root.subs" [ngValue]="sub">
                    {{ sub }}
                </option>
            </select>
            <p *ngIf="viewMode === ViewMode.VIEW">
                <ng-container *ngIf="form.value.strategic_classification">{{ form.value.strategic_classification_root?.name }} / {{ form.value.strategic_classification }}</ng-container>
                <span class="text-danger" *ngIf="!form.value.strategic_classification">Nicht eingetragen</span>
            </p>
        </div>

        <label>Ziele ({{getLengthOfFormArray('goals')}})</label>

        <p class="text-danger" *ngIf="getLengthOfFormArray('goals') === 0">
            Keine Ziele definiert.
            <span *ngIf="viewMode !== ViewMode.VIEW"><br/>Es muss mindestens ein Ziel definiert werden.</span>
        </p>

        <table class="table table-striped table-sm ms-2" *ngIf="getLengthOfFormArray('goals') > 0">
            <tbody formArrayName="goals">
            <ng-container [formGroupName]="i"
                          *ngFor="let entry of formService.getFormArray(form, 'goals').controls; let i = index">
                <tr>
                    <th style="width: 50px" *ngIf="viewMode !== ViewMode.VIEW"></th>
                    <th>Ziel {{ i + 1 }}</th>
                    <th style="width: 60px">Erfüllt</th>
                </tr>
                <tr>
                <ng-container *ngIf="!entry.value._deleted">
                    <td *ngIf="viewMode !== ViewMode.VIEW">
                        <button type="button" class="btn btn-danger btn-sm" (click)="markEntryAsDeleted(entry)"><i
                                class="fas fa-times"></i>
                        </button>
                    </td>
                    <td>
                        <textarea class="form-control" formControlName="text" rows="5"
                            placeholder="Beschreiben Sie das Ziel (Was soll erreicht werden - Unterschied zukünftiger zu gegenwärtiger Zustand) des Projekts anhand folgender Kriterien:

Spezifisch: Was genau möchte ich erreichen?
Messbar: Wie kann ich es quantifizieren?
Attraktiv: Ist es mir wichtig?
Realistisch: Kann ich mein Ziel erreichen?
Terminiert: Wann will ich mein Ziel erreichen?" *ngIf="viewMode !== ViewMode.VIEW"
                                  [disableControl]="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && accessService.hasRoles(project, TeamRole.Lead)">
                        </textarea>
                        <div *ngIf="viewMode === ViewMode.VIEW" [innerHTML]="entry.value.textWithBreaks"></div>
                    </td>
                    <td>
                        <div class="form-check" *ngIf="viewMode !== ViewMode.VIEW">
                            <input class="form-check-input" formControlName="completed" type="checkbox">
                        </div>
                        <span [class.text-danger]="!entry.value.completed"
                              [class.text-success]="entry.value.completed"
                              *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.completed | yesNo }}
                        </span>
                    </td>
                </ng-container>
                </tr>
            </ng-container>
            </tbody>
        </table>

        <div *ngIf="viewMode !== ViewMode.VIEW">
            <button type="button" class="btn btn-primary btn-sm mb-3"
                    (click)="addFormItem({}, 'goals')"
                    [disabled]="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && accessService.hasRoles(project, TeamRole.Lead)">
                <i class="fas fa-plus"></i> Ziel hinzufügen
            </button>
        </div>

        <label>Nicht-Ziele ({{getLengthOfFormArray('non_goals')}})</label>

        <p class="text-danger" *ngIf="getLengthOfFormArray('non_goals') === 0">Keine Nicht-Ziele definiert.</p>

        <table class="table table-striped table-sm ms-2" *ngIf="getLengthOfFormArray('non_goals') > 0">
            <tbody formArrayName="non_goals">
            <ng-container [formGroupName]="i"
                          *ngFor="let entry of formService.getFormArray(form, 'non_goals').controls; let i = index">
                <tr>
                    <th style="width: 50px" *ngIf="viewMode !== ViewMode.VIEW"></th>
                    <th>Nicht-Ziel {{ i + 1 }}</th>
                </tr>
                <tr>
                <ng-container *ngIf="!entry.value._deleted">
                    <td *ngIf="viewMode !== ViewMode.VIEW">
                        <button type="button" class="btn btn-danger btn-sm" (click)="markEntryAsDeleted(entry)"><i
                                class="fas fa-times"></i>
                        </button>
                    </td>
                    <td>
                        <textarea class="form-control" formControlName="text" rows="5"
                            placeholder="Definieren Sie, was im Rahmen des Projekts nicht anvisiert wird, um eine saubere Abgrenzung des Projektinhalts durchführen zu können."
                            *ngIf="viewMode !== ViewMode.VIEW"
                            [disableControl]="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && accessService.hasRoles(project, TeamRole.Lead)">
                        </textarea>
                        <div *ngIf="viewMode === ViewMode.VIEW" [innerHTML]="entry.value.textWithBreaks"></div>
                    </td>
                </ng-container>
                </tr>
            </ng-container>
            </tbody>
        </table>

        <div *ngIf="viewMode !== ViewMode.VIEW">
            <button type="button" class="btn btn-primary btn-sm mb-3"
                    (click)="addFormItem({}, 'non_goals')"
                    [disabled]="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && accessService.hasRoles(project, TeamRole.Lead)">
                <i class="fas fa-plus"></i> Nicht-Ziel hinzufügen
            </button>
        </div>

        <label>Abnahmekriterien ({{getLengthOfFormArray('criteria')}})</label>

        <p *ngIf="getLengthOfFormArray('criteria') === 0">Keine Abnahmekriterien definiert.</p>

        <table class="table table-striped table-sm ms-2" *ngIf="getLengthOfFormArray('criteria') > 0">
            <tbody formArrayName="criteria">
            <ng-container [formGroupName]="i"
                          *ngFor="let entry of formService.getFormArray(form, 'criteria').controls; let i = index">
                <tr>
                    <th style="width: 50px" *ngIf="viewMode !== ViewMode.VIEW"></th>
                    <th>Abnahmekriterium {{ i + 1 }}</th>
                    <th style="width: 60px">Erfüllt</th>
                </tr>
                <tr>
                <ng-container *ngIf="!entry.value._deleted">
                    <td *ngIf="viewMode !== ViewMode.VIEW">
                        <button type="button" class="btn btn-danger btn-sm" (click)="markEntryAsDeleted(entry)"><i
                                class="fas fa-times"></i>
                        </button>
                    </td>
                    <td>
                        <textarea class="form-control" formControlName="text" rows="5"
                            placeholder="Messbares Resultat das zur Abnahme des Projekts erfüllt sein muss"
                            *ngIf="viewMode !== ViewMode.VIEW"
                            [disableControl]="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && accessService.hasRoles(project, TeamRole.Lead)">
                        </textarea>
                        <div *ngIf="viewMode === ViewMode.VIEW" [innerHTML]="entry.value.textWithBreaks"></div>
                    </td>
                    <td>
                        <div class="form-check" *ngIf="viewMode !== ViewMode.VIEW">
                            <input class="form-check-input" formControlName="completed" type="checkbox">
                        </div>
                        <span [class.text-danger]="!entry.value.completed"
                              [class.text-success]="entry.value.completed"
                              *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.completed | yesNo }}
                        </span>
                    </td>
                </ng-container>
                </tr>
            </ng-container>
            </tbody>
        </table>

        <div *ngIf="viewMode !== ViewMode.VIEW">
            <button type="button" class="btn btn-primary btn-sm"
                    (click)="addFormItem({}, 'criteria')"
                    [disabled]="projectService.hasStatus(project, ProjectStatus.IN_PROGRESS) && accessService.hasRoles(project, TeamRole.Lead)">
                <i class="fas fa-plus"></i> Abnahmekriterium hinzufügen
            </button>
        </div>

    </form>
</div>
